import { set } from 'cerebral/operators'
import { state, props } from 'cerebral/tags'
import hasFocusedTag from '../actions/hasFocusedTag'
import unfocusTag from '../actions/unfocusTag'

export default [
  set(state`selectr.${props`namespace`}.focusInput`, props`focus`),
  hasFocusedTag,
  {
    true: [
      unfocusTag,
      set(state`selectr.${props`namespace`}.focusedTag`, null)
    ],
    false: []
  }
]
